import { render, staticRenderFns } from "./lawyerBottom.vue?vue&type=template&id=45c47f0e&scoped=true"
import script from "./lawyerBottom.vue?vue&type=script&lang=js"
export * from "./lawyerBottom.vue?vue&type=script&lang=js"
import style0 from "./lawyerBottom.vue?vue&type=style&index=0&id=45c47f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c47f0e",
  null
  
)

export default component.exports